import {
  DocumentsMenuLabel,
  DOCUMENTS_CATEGORY,
  DOCUMENTS_COLLECTION,
  TDocumentsCategory,
  IDocumentsTab,
  IDocument,
} from '.'

export const getDocumentsCategoryTabs = (
  category: TDocumentsCategory,
  documents?: IDocument[]
): IDocumentsTab[] =>
  DOCUMENTS_CATEGORY[category].collections.map((collection) => {
    const currentDocuments = documents.filter(
      (document) => document.collection === collection.key && !document.archived
    )
    return {
      collection: collection.key,
      label: collection.label,
      order: collection.categoryOrder,
      filesCount: currentDocuments.length,
      hasBorrowerDocument: currentDocuments.some(
        (document) => document.createdBy?.role === 'user'
      ),
    }
  })

export const getDrawdownCollections = (
  categoryOrder: number,
  tabOrder: number,
  drawdownUuid?: string
) => {
  const getMenuNumber = (number: number) =>
    `${categoryOrder}.${tabOrder}.${number}`

  const getCollectionKey = (key: string) => {
    if (drawdownUuid) return `${key}/${drawdownUuid}`
    return key
  }

  return [
    {
      key: getCollectionKey(DOCUMENTS_COLLECTION.invoices.key),
      label: (
        <DocumentsMenuLabel
          number={getMenuNumber(1)}
          label={DOCUMENTS_COLLECTION.invoices.label}
        />
      ),
    },
    {
      key: getCollectionKey('certificates'),
      label: (
        <DocumentsMenuLabel number={getMenuNumber(2)} label="Certificates" />
      ),
      children: [
        {
          key: getCollectionKey(DOCUMENTS_COLLECTION.buildingInspections.key),
          label: DOCUMENTS_COLLECTION.buildingInspections.label,
        },
        {
          key: getCollectionKey(
            DOCUMENTS_COLLECTION.geotechAndSurveyReports.key
          ),
          label: DOCUMENTS_COLLECTION.geotechAndSurveyReports.label,
        },
        {
          key: getCollectionKey(DOCUMENTS_COLLECTION.engineerReports.key),
          label: DOCUMENTS_COLLECTION.engineerReports.label,
        },
        {
          key: getCollectionKey(
            DOCUMENTS_COLLECTION.utilityCertificationAndCompliance.key
          ),
          label: DOCUMENTS_COLLECTION.utilityCertificationAndCompliance.label,
        },
        {
          key: getCollectionKey(DOCUMENTS_COLLECTION.qsReports.key),
          label: DOCUMENTS_COLLECTION.qsReports.label,
        },
        {
          key: getCollectionKey(DOCUMENTS_COLLECTION.cccAndTitles.key),
          label: DOCUMENTS_COLLECTION.cccAndTitles.label,
        },
        {
          key: getCollectionKey(DOCUMENTS_COLLECTION.preSales.key),
          label: DOCUMENTS_COLLECTION.preSales.label,
        },
      ],
    },
    {
      key: getCollectionKey(DOCUMENTS_COLLECTION.developmentSitePhotos.key),
      label: <DocumentsMenuLabel number={getMenuNumber(3)} label="Photos" />,
    },
    {
      key: getCollectionKey(DOCUMENTS_COLLECTION.drawdownNotices.key),
      label: (
        <DocumentsMenuLabel
          number={getMenuNumber(4)}
          label={DOCUMENTS_COLLECTION.drawdownNotices.label}
        />
      ),
    },
  ]
}
